module.exports = __webpack_public_path__ + "img/hotsys_4.6ecf1e49.png";